
import { Component, Mixins, Emit, Watch } from 'vue-property-decorator';
import store from '@/store';
import $ from 'jquery';
import magnificPopup from 'magnific-popup';
import DefaultLayout from './DefaultLayout';
import CommonHeader from '@/components/common/CommonHeaderJa.vue';
import CommonFooter from '@/components/common/CommonFooterJa.vue';
import ModalFavoritesAlert from '@/components/modal/ModalFavoritesAlert/ModalFavoritesAlert.vue';
import NaviFollowSearchnavi from '@/components/navi/NaviFollowSearchnavi/NaviFollowSearchnavi.vue';
import ModalTodayLowestPrice from '@/components/modal/ModalTodayLowestPrice/ModalTodayLowestPrice.vue';
import ModalMovie from '@/components/modal/ModalMovie/ModalMovie.vue';
import ModalSearchnavi from '@/components/modal/ModalSearchnavi/ModalSearchnavi.vue';
import ModalSearch from '@/components/modal/ModalSearch/ModalSearch.vue';
import ModalMghrwcLogin from '@/components/modal/ModalMghrwcLogin/ModalMghrwcLogin.vue';
// import GlobalMenu from './GlobalMenu/GlobalMenu.vue';
import FloatBottom from '@/components/navi/FloatBottom/FloatBottom.vue';
import FloatingBanner from '@/components/button/FloatingBanner.vue';
@Component({
  components: {
    CommonHeader,
    CommonFooter,
    ModalFavoritesAlert,
    ModalSearch,
    NaviFollowSearchnavi,
    ModalTodayLowestPrice,
    ModalMovie,
    ModalSearchnavi,
    // GlobalMenu,
    FloatBottom,
    FloatingBanner,
    ModalMghrwcLogin,
  },
})
export default class DefaultLayoutJa extends Mixins(DefaultLayout) {

  @Watch('$store.state.auth.token', { immediate: true, deep: true })
  private onChangeAuthToken() {
    this.getData();
  }

  @Emit()
  private async getData() {
    if (store.getters['auth/token']){
      store.dispatch("latestMenu/update")
    }
  }

}
